import React, { useState } from "react";

import Header from "../../components/CommunicationHub/Header";
import { Box, Button, Chip, Tab, Tabs, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import AssignDialog from "../../components/CommunicationHub/AssignDialog";
import useApi from "../../hooks/useApi";
import CommunicationHubApis from "../../services/api/CommunicationHub";
import ToggleActive from "../../components/CommunicationHub/ToggleActive";
import {
  elementType,
  pathMappings,
} from "../../components/CommunicationHub/constants";
import useOptions from "../../components/CommunicationHub/hooks/useOptions";
import usePagination from "../../hooks/usePagination";
import Pagination from "../../components/Common/Pagination/Pagination";
import LoadingComponent from "../../components/CommunicationHub/LoadingComponent";
import ErrorComponent from "../../components/CommunicationHub/ErrorComponent";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import RenderIf from "../../components/Common/RenderIf/RenderIf";

const CommunicationHub = ({}) => {
  const [activeTab, setActiveTab] = useState(elementType[0].key);
  const activeTabKey = pathMappings[activeTab];
  const history = useHistory();
  const { page, perPage, handlePagination } = usePagination();
  const {
    error: optionsError,
    isLoading: isOptionsLoading,
    options,
  } = useOptions();

  const allActions = MenuActionsMappings[MenuNames.COMMUNICATION_HUB];
  const { data, isLoading, error, refetch } = useApi({
    queryKey: [activeTab, page, perPage],
    queryFn: () =>
      CommunicationHubApis.getList({
        element_type: activeTabKey,
        page_request: {
          page,
          page_size: perPage,
        },
      }),
    initialData: {
      page_response: {
        previous_page: -1,
        next_page: -1,
        items_count: 20,
      },
      elements: [],
    },
  });

  if (isLoading || isOptionsLoading) return <LoadingComponent />;

  if (error || optionsError) return <ErrorComponent />;

  return (
    <Box>
      <Header options={options} tag={activeTab} />
      <Box bgcolor={"white"}>
        <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)}>
          {elementType.map((tab) => (
            <Tab key={tab.key} label={tab.label} value={tab.key} />
          ))}
        </Tabs>

        {data.elements?.map((item) => (
          <Box
            key={item.element_id}
            display={"flex"}
            p={2}
            justifyContent={"space-between"}
            sx={{
              borderRadius: 2,
              "&:hover": {
                bgcolor: "#faeeee",
              },
            }}
          >
            <Box display={"flex"} flex gap={2}>
              <img
                src={item.thumbnail}
                alt={item.name}
                style={{
                  height: "100%",
                  aspectRatio: "1/1",
                  maxWidth: 100,
                  borderRadius: 8,
                  cursor: "pointer",
                }}
                onClick={() =>
                  history.push(
                    `communication-hub/${activeTab}/${item.element_id}`
                  )
                }
              />
              <Box>
                <Typography variant="h6">{item.name}</Typography>
                <Box
                  mb={"12px"}
                  sx={{
                    "& > p": {
                      fontSize: "14px !important",
                      lineHeight: 1,
                      color: "dimgray",
                      fontStyle: "italic",
                      "& > span": {
                        color: "#1a1a1a",
                      },
                    },
                  }}
                >
                  <Typography variant="body2">
                    Last edited on <span>{item.updated_at}</span>,
                  </Typography>
                  <Typography
                    variant="body2"
                    lineHeight={1}
                    fontStyle={"italic"}
                  >
                    by <span>{item.updated_by}</span>
                  </Typography>
                </Box>
                <RenderIf
                  condition={activeTabKey === "COMMUNICATION_TYPE_VIDEO"}
                >
                  <Typography variant="body2" display={"flex"} gap={1}>
                    <span style={{ fontWeight: 500 }}>Tags:</span>{" "}
                    {options?.tags
                      ?.filter((option) =>
                        (item?.tags ?? [])?.includes(option.value)
                      )
                      ?.map((item) => (
                        <Chip
                          size="small"
                          key={item.value}
                          label={item.label}
                          color="info"
                          variant="outlined"
                          sx={{ fontSize: "14px !important" }}
                        />
                      ))}
                  </Typography>
                </RenderIf>
              </Box>
            </Box>
            <Box>
              <Permission requiredPerms={[allActions.COMMUNICATION_HUB_CREATE]}>
                <ToggleActive
                  elementId={item.element_id}
                  elementType={activeTabKey}
                  isActive={item.is_active}
                  callback={refetch}
                />
              </Permission>

              <Permission requiredPerms={[allActions.COMMUNICATION_HUB_ASSIGN]}>
                <AssignDialog
                  options={options}
                  elementId={item.element_id}
                  elementType={activeTabKey}
                />
              </Permission>
              <RenderIf condition={activeTabKey === "COMMUNICATION_TYPE_VIDEO"}>
                <Button
                  color="error"
                  onClick={() =>
                    history.push(
                      `communication-hub/history/${activeTab}/${item.element_id}?title=${item.name}`
                    )
                  }
                >
                  History
                </Button>
              </RenderIf>
              <Button
                color="error"
                onClick={() =>
                  history.push(
                    `communication-hub/${activeTab}/${item.element_id}`
                  )
                }
              >
                View
              </Button>
            </Box>
          </Box>
        ))}
        <Pagination
          page={page - 1}
          perPage={perPage}
          previousPage={data?.page_response?.previous_page ?? -1}
          nextPage={data?.page_response?.next_page ?? -1}
          onPageChange={handlePagination}
        />
      </Box>
    </Box>
  );
};

export default CommunicationHub;
